// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer-S4k8j","allStudentsReport":"allStudentsReport-mGZlV","spacer":"spacer-ZF7PZ","info":"info-gCBWO"};